import { WSFlexBox, WSIcon, WSText } from "@wingspanhq/fe-component-library";
import { useMemo } from "react";

import { selectorSearchRowName } from "../../../shared/selectors/selectorSearchRowName";
import { queriesPayeeRows } from "../../../v3/query/queriesPayeeRows";
import { useXWingspanPayerId } from "../../Payees/routes/RoutePayeeDetails/useXWingspanPayerId";

type Props = {
  payeeId: string;
};

export const LablePayeeName: React.FC<Props> = props => {
  const xWingspanAccount = useXWingspanPayerId();
  // Name off the search row's server-resolved `profile.resolvedName`, the same
  // string the contractor list and requirement tables show.
  const queryPayeeRow = queriesPayeeRows.searchPayeeRows.useQuery({
    filter: { id: { eq: props.payeeId } },
    page: { size: 1 },
    xWingspanAccount
  });

  const name = useMemo(() => {
    const payeeRow = queryPayeeRow.data?.data?.[0];

    if (!payeeRow) {
      return;
    }

    return selectorSearchRowName(payeeRow);
  }, [queryPayeeRow.data]);

  if (!name) {
    return null;
  }

  return (
    <WSFlexBox alignItems="center" gap="XS" wrap="nowrap">
      <WSIcon color="gray600" name="user" size="S" />
      <WSText.ParagraphXs color="gray600">{name}</WSText.ParagraphXs>
    </WSFlexBox>
  );
};
